import { useLocation } from "react-router";

export const useSectionUriParams = () => {
  const location = useLocation();

  // Get url search parameters
  const query = new URLSearchParams(location.search);

  // Return section infos
  return {
    layout_index: query.get("layout_index"),
    repetition_index: query.get("repetition_index"),
    asset_id: query.get("asset_id"),
  };
};
